import { PropsWithChildren } from 'react'
import { Link } from '@skedulo/breeze-ui-react'
import { DEV_DOCS_PLATFORM_ERROR_CODES_URL, UIErrorCode } from '../constants'
import type { ErrorFallbackProps } from './error-fallback'

export type ErrorDetailProps = Pick<ErrorFallbackProps, 'code' | 'traceId'> & {
  message?: string
}

export const buildErrorCodeDocsAnchorURL = (
  code: UIErrorCode | string = UIErrorCode.UNKNOWN,
) => {
  const anchor =
    code === UIErrorCode.UNKNOWN ? '' : `#${encodeURIComponent(code)}`

  return `${DEV_DOCS_PLATFORM_ERROR_CODES_URL}${anchor}`
}

/**
 * Renders a consistent format for an error code and trace ID if defined. Also
 * accepts any child content, such as a friendly error message.
 */
export const ErrorDetail = ({
  children,
  message,
  code = UIErrorCode.UNKNOWN,
  traceId,
}: PropsWithChildren<ErrorDetailProps>) => {
  const codeMarkup =
    code === UIErrorCode.UNKNOWN ? (
      code
    ) : (
      <Link href={buildErrorCodeDocsAnchorURL(code)} target="_blank">
        {code}
      </Link>
    )

  return (
    <>
      {children}
      {message && <div>Error: {message}</div>}
      <div>Error code : {codeMarkup}</div>
      {traceId && <div>Trace ID : {traceId}</div>}
    </>
  )
}
